var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEShopLogoSmall = function SvgEShopLogoSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.795,
    height: 34.842,
    viewBox: "0 0 190.795 34.842",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1ruyg4k9fa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5879",
    style: {
      fill: "none"
    },
    d: "M0 0h127.522v8.851H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3273"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "1O1O-logo"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3208",
    d: "M6.538 34.842h42.99V0H6.538z",
    transform: "translate(-3.411)",
    style: {
      fillRule: "evenodd",
      fill: "#ffdc00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1627"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3209",
    d: "M58.662 7.645a29.387 29.387 0 0 0-3.11-1.358 8.213 8.213 0 0 1-2.062-.9c-.923-.386-2.155-.374-2.927-.744-.67-.178-1.43-.706-2.162-.354-.511-.327-.755.071-1.569-.635-.207-.3 2.465.042 2.6.058l.268.035c.407.1.434.323 1 .287l.852.267a3.247 3.247 0 0 1 1.248-.05c-.962-.447-1.028-.181-1.472-.288l-.379-.224c-.25-.209-1.008-.162-1.406-.3l-.338-.189c-.492-.5-1.247-.393-2.269-.622S40.25 1.251 38.658 1.05A63.077 63.077 0 0 0 27.055.2 93.606 93.606 0 0 0 5.563 2.579c-2.722.619-2.651.075-3.387.518C1.607 3.439.684 4.114.631 4.869.5 6.911.415 6.519.041 7.387S2.029 9.272 3 9.22s.9-.564 2.679-1.544a19.236 19.236 0 0 1 5.185-1.783 51.894 51.894 0 0 1 8.35-1.793c.371-.042.994.18 1.6.146 5.8-.681 20.628-.146 28.776 2.222 1.357.459-.43-.4-.012-.473s1.181.251 1.621.047l.116.185a1 1 0 0 0 1.041.408c.807.189 1.416-.065 1.9.437.145-.07.5.148.512.06a9.306 9.306 0 0 0-2.384-1.027c1.413-.15 6.371 1.594 6.279 1.539",
    transform: "translate(0 9.904)",
    style: {
      fill: "#939597",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3210",
    d: "M12.885 27.565v-3.307h3.132V35.1h-2.57v-7.535z",
    transform: "translate(-6.723 -11.017)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3211",
    d: "M12.885 27.565v-3.307h3.132V35.1h-2.57v-7.535z",
    transform: "translate(-6.723 -11.017)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3212",
    d: "M31.069 32.151a2.681 2.681 0 1 1 2.686-2.674 2.687 2.687 0 0 1-2.686 2.674m-.012-8.293a5.61 5.61 0 1 0 5.616 5.61 5.609 5.609 0 0 0-5.616-5.61",
    transform: "translate(-13.279 -10.809)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3213",
    d: "M31.069 32.151a2.681 2.681 0 1 1 2.686-2.674 2.687 2.687 0 0 1-2.686 2.674zm-.012-8.293a5.61 5.61 0 1 0 5.616 5.61 5.609 5.609 0 0 0-5.616-5.609z",
    transform: "translate(-13.279 -10.809)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3214",
    d: "M72.177 32.151a2.681 2.681 0 1 1 2.684-2.674 2.682 2.682 0 0 1-2.684 2.674m0-8.293a5.61 5.61 0 1 0 5.607 5.61 5.612 5.612 0 0 0-5.607-5.61",
    transform: "translate(-34.732 -10.809)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3215",
    d: "M72.177 32.151a2.681 2.681 0 1 1 2.684-2.674 2.682 2.682 0 0 1-2.684 2.674zm0-8.293a5.61 5.61 0 1 0 5.607 5.61 5.612 5.612 0 0 0-5.607-5.609z",
    transform: "translate(-34.732 -10.809)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3216",
    d: "M54.006 27.565v-3.307h3.132V35.1h-2.56v-7.535z",
    transform: "translate(-28.179 -11.017)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3217",
    d: "M54.006 27.565v-3.307h3.132V35.1h-2.56v-7.535z",
    transform: "translate(-28.179 -11.017)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3218",
    d: "M102.1 1.852h.561c.3 0 .583.094.583.418 0 .364-.227.448-.583.448h-.561zm-.461 2.495h.461V3.078h.4l.788 1.268h.5l-.809-1.268a.73.73 0 0 0 .741-.79c0-.536-.325-.806-.983-.806h-1.095zM100.6 2.913a1.972 1.972 0 1 1 3.939 0 1.972 1.972 0 1 1-3.939 0zm-.47 0a2.44 2.44 0 1 0 2.44-2.436 2.445 2.445 0 0 0-2.44 2.436z",
    transform: "translate(-52.248 1.391)",
    style: {
      fillRule: "evenodd",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3080"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3078",
    transform: "translate(63.273 5.719)",
    style: {
      clipPath: "url(#1ruyg4k9fa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4313",
    d: "M3.819.163A4.664 4.664 0 0 1 4.9.288a5.44 5.44 0 0 1 1.14.426v1.177a5.359 5.359 0 0 0-1.1-.5 3.653 3.653 0 0 0-1.059-.153 2.694 2.694 0 0 0-1.246.285 2.094 2.094 0 0 0-.864.8 2.217 2.217 0 0 0-.308 1.154 2.233 2.233 0 0 0 .306 1.163 2.052 2.052 0 0 0 .862.795 2.738 2.738 0 0 0 1.251.28 3.363 3.363 0 0 0 1.017-.153A7.4 7.4 0 0 0 6.12 5.01V6.2a5.65 5.65 0 0 1-1.158.468 4.871 4.871 0 0 1-1.24.132 4 4 0 0 1-1.831-.4A3.062 3.062 0 0 1 .624 5.221a3.2 3.2 0 0 1-.461-1.68 3.3 3.3 0 0 1 .475-1.756 3.186 3.186 0 0 1 1.307-1.2A4.086 4.086 0 0 1 3.819.163",
    transform: "translate(-.107 -.107)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4314",
    d: "M3.819.163A4.664 4.664 0 0 1 4.9.288a5.44 5.44 0 0 1 1.14.426v1.177a5.359 5.359 0 0 0-1.1-.5 3.653 3.653 0 0 0-1.059-.153 2.694 2.694 0 0 0-1.246.285 2.094 2.094 0 0 0-.864.8 2.217 2.217 0 0 0-.308 1.154 2.233 2.233 0 0 0 .306 1.163 2.052 2.052 0 0 0 .862.795 2.738 2.738 0 0 0 1.251.28 3.363 3.363 0 0 0 1.017-.153A7.4 7.4 0 0 0 6.12 5.01V6.2a5.65 5.65 0 0 1-1.158.468 4.871 4.871 0 0 1-1.24.132 4 4 0 0 1-1.831-.4A3.062 3.062 0 0 1 .624 5.221a3.2 3.2 0 0 1-.461-1.68 3.3 3.3 0 0 1 .475-1.756 3.186 3.186 0 0 1 1.307-1.2A4.086 4.086 0 0 1 3.819.163z",
    transform: "translate(-.107 -.107)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4315",
    d: "M22.335 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.233-.295 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.214-.28m-1.179 2.232a1.585 1.585 0 0 0 .318 1.034 1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061A1.472 1.472 0 0 0 23.2 7.64a1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.324 1.006",
    transform: "translate(-13.137 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4316",
    d: "M22.335 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.233-.295 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.212-.277zm-1.177 2.229a1.585 1.585 0 0 0 .318 1.034 1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061A1.472 1.472 0 0 0 23.2 7.64a1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.324 1.005z",
    transform: "translate(-13.137 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4317",
    d: "M39.01 6.437a1.061 1.061 0 0 1 .448.1 2.525 2.525 0 0 1 .512.343l-.408 1a1.5 1.5 0 0 0-.8-.371.853.853 0 0 0-.521.2 1.4 1.4 0 0 0-.412.521 1.491 1.491 0 0 0-.155.649v1.974h-1.14V6.52h1.14v1.1h.018a3.017 3.017 0 0 1 .626-.906 1.018 1.018 0 0 1 .69-.28",
    transform: "translate(-24.043 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4318",
    d: "M39.01 6.437a1.061 1.061 0 0 1 .448.1 2.525 2.525 0 0 1 .512.343l-.408 1a1.5 1.5 0 0 0-.8-.371.853.853 0 0 0-.521.2 1.4 1.4 0 0 0-.412.521 1.491 1.491 0 0 0-.155.649v1.974h-1.14V6.52h1.14v1.1h.018a3.017 3.017 0 0 1 .626-.906 1.018 1.018 0 0 1 .692-.277z",
    transform: "translate(-24.043 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4319",
    d: "M50.365 6.438a1.931 1.931 0 0 1 1.495.621 2.305 2.305 0 0 1 .568 1.617 2.507 2.507 0 0 1-.266 1.168 1.948 1.948 0 0 1-.758.8 2.162 2.162 0 0 1-1.112.287 2.248 2.248 0 0 1-1.015-.255v2.354h-1.14V6.521h1.131V6.8a1.872 1.872 0 0 1 1.1-.361m-1.091 3.405a1.608 1.608 0 0 0 .8.246 1.071 1.071 0 0 0 .862-.384 1.487 1.487 0 0 0 .325-.992 1.663 1.663 0 0 0-.29-1.038.978.978 0 0 0-.823-.375 1.119 1.119 0 0 0-.385.067 2.189 2.189 0 0 0-.486.285z",
    transform: "translate(-31.677 -4.237)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4320",
    d: "M50.365 6.438a1.931 1.931 0 0 1 1.495.621 2.305 2.305 0 0 1 .568 1.617 2.507 2.507 0 0 1-.266 1.168 1.948 1.948 0 0 1-.758.8 2.162 2.162 0 0 1-1.112.287 2.248 2.248 0 0 1-1.015-.255v2.354h-1.14V6.521h1.131V6.8a1.872 1.872 0 0 1 1.097-.362zm-1.088 3.406a1.608 1.608 0 0 0 .8.246 1.071 1.071 0 0 0 .862-.384 1.487 1.487 0 0 0 .325-.992 1.663 1.663 0 0 0-.29-1.038.978.978 0 0 0-.823-.375 1.119 1.119 0 0 0-.385.067 2.189 2.189 0 0 0-.486.285z",
    transform: "translate(-31.677 -4.237)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4321",
    d: "M65.05 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.214-.28m-1.175 2.229a1.585 1.585 0 0 0 .318 1.034 1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.324 1.006",
    transform: "translate(-41.246 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4322",
    d: "M65.05 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.216-.28zm-1.177 2.229a1.585 1.585 0 0 0 .318 1.034 1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.323 1.007z",
    transform: "translate(-41.246 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4323",
    d: "M81.725 6.437a1.061 1.061 0 0 1 .448.1 2.526 2.526 0 0 1 .512.343l-.408 1a1.5 1.5 0 0 0-.8-.371.853.853 0 0 0-.521.2 1.4 1.4 0 0 0-.412.521 1.491 1.491 0 0 0-.155.649v1.974h-1.14V6.52h1.14v1.1h.018a3.017 3.017 0 0 1 .626-.906 1.018 1.018 0 0 1 .69-.28",
    transform: "translate(-52.152 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4324",
    d: "M81.725 6.437a1.061 1.061 0 0 1 .448.1 2.526 2.526 0 0 1 .512.343l-.408 1a1.5 1.5 0 0 0-.8-.371.853.853 0 0 0-.521.2 1.4 1.4 0 0 0-.412.521 1.491 1.491 0 0 0-.155.649v1.974h-1.14V6.52h1.14v1.1h.018a3.017 3.017 0 0 1 .626-.906 1.018 1.018 0 0 1 .692-.277z",
    transform: "translate(-52.152 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4325",
    d: "M91.856 6.437a1.992 1.992 0 0 1 1.274.355 1.2 1.2 0 0 1 .44.99V9.9q0 .246.2.246a.6.6 0 0 0 .23-.074 1.048 1.048 0 0 0 .253-.164v.658a2.134 2.134 0 0 1-1.094.366.9.9 0 0 1-.47-.1.557.557 0 0 1-.229-.361 2.255 2.255 0 0 1-1.312.464 1.133 1.133 0 0 1-.8-.315 1 1 0 0 1-.336-.755 1.177 1.177 0 0 1 .333-.885 2.84 2.84 0 0 1 1.168-.566l.922-.268v-.2q0-.635-.769-.635a1.839 1.839 0 0 0-.783.181 2.225 2.225 0 0 0-.71.533V7a2.632 2.632 0 0 1 1.682-.561m-.7 3.253a.5.5 0 0 0 .15.38.52.52 0 0 0 .373.144 1.122 1.122 0 0 0 .751-.343V8.731a5.317 5.317 0 0 0-.748.306 1.369 1.369 0 0 0-.4.292.534.534 0 0 0-.128.361",
    transform: "translate(-59.234 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4326",
    d: "M91.856 6.437a1.992 1.992 0 0 1 1.274.355 1.2 1.2 0 0 1 .44.99V9.9q0 .246.2.246a.6.6 0 0 0 .23-.074 1.048 1.048 0 0 0 .253-.164v.658a2.134 2.134 0 0 1-1.094.366.9.9 0 0 1-.47-.1.557.557 0 0 1-.229-.361 2.255 2.255 0 0 1-1.312.464 1.133 1.133 0 0 1-.8-.315 1 1 0 0 1-.336-.755 1.177 1.177 0 0 1 .333-.885 2.84 2.84 0 0 1 1.168-.566l.922-.268v-.2q0-.635-.769-.635a1.839 1.839 0 0 0-.783.181 2.225 2.225 0 0 0-.71.533V7a2.632 2.632 0 0 1 1.683-.563zm-.7 3.253a.5.5 0 0 0 .15.38.52.52 0 0 0 .373.144 1.122 1.122 0 0 0 .751-.343v-1.14a5.317 5.317 0 0 0-.748.306 1.369 1.369 0 0 0-.4.292.534.534 0 0 0-.121.361z",
    transform: "translate(-59.234 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4327",
    d: "M104.414 3.321h.093V4.47h1.483v.862h-1.483v2a.614.614 0 0 0 .658.653 1.95 1.95 0 0 0 .917-.287v.913a2.861 2.861 0 0 1-1.158.274 1.57 1.57 0 0 1-1.142-.4 1.438 1.438 0 0 1-.41-1.08V5.332h-.672v-.185z",
    transform: "translate(-67.58 -2.186)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4328",
    d: "M104.414 3.321h.093V4.47h1.483v.862h-1.483v2a.614.614 0 0 0 .658.653 1.95 1.95 0 0 0 .917-.287v.913a2.861 2.861 0 0 1-1.158.274 1.57 1.57 0 0 1-1.142-.4 1.438 1.438 0 0 1-.41-1.08V5.332h-.672v-.185z",
    transform: "translate(-67.58 -2.186)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4329",
    d: "M116 6.437a1.941 1.941 0 0 1 1.511.612 2.423 2.423 0 0 1 .556 1.692v.171H115a1.333 1.333 0 0 0 .433.892 1.481 1.481 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.412 3.412 0 0 0 .782-.43v.848a3.11 3.11 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.157 2.157 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613A2.069 2.069 0 0 1 116 6.437m1 1.784a1.252 1.252 0 0 0-.287-.739.849.849 0 0 0-.663-.266.952.952 0 0 0-.693.255 1.256 1.256 0 0 0-.331.751z",
    transform: "translate(-74.911 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4330",
    d: "M116 6.437a1.941 1.941 0 0 1 1.511.612 2.423 2.423 0 0 1 .556 1.692v.171H115a1.333 1.333 0 0 0 .433.892 1.481 1.481 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.412 3.412 0 0 0 .782-.43v.848a3.11 3.11 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.157 2.157 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613A2.069 2.069 0 0 1 116 6.437zm1 1.784a1.252 1.252 0 0 0-.287-.739.849.849 0 0 0-.663-.266.952.952 0 0 0-.693.255 1.256 1.256 0 0 0-.331.751z",
    transform: "translate(-74.911 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4331",
    d: "M141.138.407v.978h-2.933v1.7h2.808v.978h-2.808V5.9h3v.98h-4.249V.407z",
    transform: "translate(-90.125 -.268)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4332",
    d: "M141.138.407v.978h-2.933v1.7h2.808v.978h-2.808V5.9h3v.98h-4.249V.407z",
    transform: "translate(-90.125 -.268)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4333",
    d: "M154.884 6.437a1.474 1.474 0 0 1 .846.234 1.432 1.432 0 0 1 .516.628 2.687 2.687 0 0 1 .73-.656 1.592 1.592 0 0 1 .8-.206 1.452 1.452 0 0 1 1.108.447 1.667 1.667 0 0 1 .422 1.193v2.771h-1.14V8.267a1.167 1.167 0 0 0-.193-.709.652.652 0 0 0-.558-.26 1.307 1.307 0 0 0-1.005.672v2.877h-1.135v-2.6a1.083 1.083 0 0 0-.2-.7.667.667 0 0 0-.547-.252.88.88 0 0 0-.51.16 2.291 2.291 0 0 0-.5.512v2.877h-1.14V6.52h1.14v.607a2.281 2.281 0 0 1 .631-.521 1.55 1.55 0 0 1 .737-.169",
    transform: "translate(-100.274 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4334",
    d: "M154.884 6.437a1.474 1.474 0 0 1 .846.234 1.432 1.432 0 0 1 .516.628 2.687 2.687 0 0 1 .73-.656 1.592 1.592 0 0 1 .8-.206 1.452 1.452 0 0 1 1.108.447 1.667 1.667 0 0 1 .422 1.193v2.771h-1.14V8.267a1.167 1.167 0 0 0-.193-.709.652.652 0 0 0-.558-.26 1.307 1.307 0 0 0-1.005.672v2.877h-1.135v-2.6a1.083 1.083 0 0 0-.2-.7.667.667 0 0 0-.547-.252.88.88 0 0 0-.51.16 2.291 2.291 0 0 0-.5.512v2.877h-1.14V6.52h1.14v.607a2.281 2.281 0 0 1 .631-.521 1.55 1.55 0 0 1 .735-.169z",
    transform: "translate(-100.274 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4335",
    d: "M178.09 6.438a1.929 1.929 0 0 1 1.494.621 2.305 2.305 0 0 1 .568 1.617 2.5 2.5 0 0 1-.266 1.168 1.946 1.946 0 0 1-.758.8 2.161 2.161 0 0 1-1.112.287 2.246 2.246 0 0 1-1.016-.253v2.354h-1.14V6.521h1.131V6.8a1.875 1.875 0 0 1 1.1-.361M177 9.844a1.609 1.609 0 0 0 .8.246 1.071 1.071 0 0 0 .862-.384 1.489 1.489 0 0 0 .324-.992 1.661 1.661 0 0 0-.29-1.038.978.978 0 0 0-.822-.375 1.119 1.119 0 0 0-.385.067 2.187 2.187 0 0 0-.487.285z",
    transform: "translate(-115.728 -4.237)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4336",
    d: "M178.09 6.438a1.929 1.929 0 0 1 1.494.621 2.305 2.305 0 0 1 .568 1.617 2.5 2.5 0 0 1-.266 1.168 1.946 1.946 0 0 1-.758.8 2.161 2.161 0 0 1-1.112.287 2.246 2.246 0 0 1-1.016-.253v2.354h-1.14V6.521h1.131V6.8a1.875 1.875 0 0 1 1.099-.362zM177 9.844a1.609 1.609 0 0 0 .8.246 1.071 1.071 0 0 0 .862-.384 1.489 1.489 0 0 0 .324-.992 1.661 1.661 0 0 0-.29-1.038.978.978 0 0 0-.822-.375 1.119 1.119 0 0 0-.385.067 2.187 2.187 0 0 0-.487.285z",
    transform: "translate(-115.728 -4.237)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5875",
    transform: "translate(65.369 .139)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h1.14v6.473H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5876",
    transform: "translate(65.369 .139)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    },
    d: "M0 0h1.14v6.473H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4337",
    d: "M199.659 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.214-.28m-1.177 2.229a1.585 1.585 0 0 0 .32 1.034 1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.324 1.006",
    transform: "translate(-129.828 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4338",
    d: "M199.659 6.437a2.652 2.652 0 0 1 1.228.283 2.054 2.054 0 0 1 .852.792 2.224 2.224 0 0 1 .3 1.154 2.326 2.326 0 0 1-.289 1.177 2.031 2.031 0 0 1-.853.8 2.652 2.652 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.036 2.036 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.622 2.622 0 0 1 1.216-.28zm-1.177 2.229A1.585 1.585 0 0 0 198.8 9.7a1.044 1.044 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.057 1.057 0 0 0-.844.38 1.5 1.5 0 0 0-.323 1.007z",
    transform: "translate(-129.828 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4339",
    d: "m213.453 6.681 1.024 2.326 1.038-2.326h1.223l-2.989 6.51h-1.223l1.376-2.98-1.682-3.531z",
    transform: "translate(-139.656 -4.397)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4340",
    d: "m213.453 6.681 1.024 2.326 1.038-2.326h1.223l-2.989 6.51h-1.223l1.376-2.98-1.682-3.531z",
    transform: "translate(-139.656 -4.397)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4341",
    d: "M228.628 6.437a1.94 1.94 0 0 1 1.511.612 2.421 2.421 0 0 1 .556 1.692v.171h-3.063a1.334 1.334 0 0 0 .433.892 1.482 1.482 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.41 3.41 0 0 0 .781-.429v.848a3.108 3.108 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.156 2.156 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613 2.068 2.068 0 0 1 1.564-.626m1 1.784a1.254 1.254 0 0 0-.287-.739.849.849 0 0 0-.663-.266.952.952 0 0 0-.693.255 1.258 1.258 0 0 0-.331.751z",
    transform: "translate(-149.029 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4342",
    d: "M228.628 6.437a1.94 1.94 0 0 1 1.511.612 2.421 2.421 0 0 1 .556 1.692v.171h-3.063a1.334 1.334 0 0 0 .433.892 1.482 1.482 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.41 3.41 0 0 0 .781-.429v.848a3.108 3.108 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.156 2.156 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613 2.068 2.068 0 0 1 1.563-.626zm1 1.784a1.254 1.254 0 0 0-.287-.739.849.849 0 0 0-.663-.266.952.952 0 0 0-.693.255 1.258 1.258 0 0 0-.331.751z",
    transform: "translate(-149.029 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4343",
    d: "M242.952 6.437a1.94 1.94 0 0 1 1.511.612 2.421 2.421 0 0 1 .556 1.692v.171h-3.063a1.334 1.334 0 0 0 .433.892 1.482 1.482 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.412 3.412 0 0 0 .781-.429v.848a3.108 3.108 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.156 2.156 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613 2.068 2.068 0 0 1 1.564-.626m1 1.784a1.254 1.254 0 0 0-.287-.739.849.849 0 0 0-.666-.266.952.952 0 0 0-.693.255 1.258 1.258 0 0 0-.331.751z",
    transform: "translate(-158.455 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4344",
    d: "M242.952 6.437a1.94 1.94 0 0 1 1.511.612 2.421 2.421 0 0 1 .556 1.692v.171h-3.063a1.334 1.334 0 0 0 .433.892 1.482 1.482 0 0 0 1 .313 2.219 2.219 0 0 0 .785-.141 3.412 3.412 0 0 0 .781-.429v.848a3.108 3.108 0 0 1-1.844.538 2.33 2.33 0 0 1-1.673-.617 2.156 2.156 0 0 1-.649-1.64 2.233 2.233 0 0 1 .6-1.613 2.068 2.068 0 0 1 1.563-.626zm1 1.784a1.254 1.254 0 0 0-.287-.739.849.849 0 0 0-.665-.266.952.952 0 0 0-.693.255 1.258 1.258 0 0 0-.331.751z",
    transform: "translate(-158.455 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4345",
    d: "M265.141.163a3.787 3.787 0 0 1 1.821.473v1.112a3.562 3.562 0 0 0-1.784-.607 1.292 1.292 0 0 0-.739.183.566.566 0 0 0-.266.489q0 .366.5.676.139.093 1.07.519a3.072 3.072 0 0 1 1.149.834 1.758 1.758 0 0 1 .353 1.1 1.683 1.683 0 0 1-.6 1.346 2.312 2.312 0 0 1-1.554.512 3.685 3.685 0 0 1-1.068-.137 4.644 4.644 0 0 1-1-.47V4.964a3.145 3.145 0 0 0 1.956.862 1.261 1.261 0 0 0 .741-.2.618.618 0 0 0 .283-.528.835.835 0 0 0-.491-.732q-.408-.223-1.052-.533a3.09 3.09 0 0 1-1.142-.811 1.65 1.65 0 0 1-.378-1.075 1.576 1.576 0 0 1 .607-1.3 2.494 2.494 0 0 1 1.6-.484",
    transform: "translate(-173.026 -.107)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4346",
    d: "M265.141.163a3.787 3.787 0 0 1 1.821.473v1.112a3.562 3.562 0 0 0-1.784-.607 1.292 1.292 0 0 0-.739.183.566.566 0 0 0-.266.489q0 .366.5.676.139.093 1.07.519a3.072 3.072 0 0 1 1.149.834 1.758 1.758 0 0 1 .353 1.1 1.683 1.683 0 0 1-.6 1.346 2.312 2.312 0 0 1-1.554.512 3.685 3.685 0 0 1-1.068-.137 4.644 4.644 0 0 1-1-.47V4.964a3.145 3.145 0 0 0 1.956.862 1.261 1.261 0 0 0 .741-.2.618.618 0 0 0 .283-.528.835.835 0 0 0-.491-.732q-.408-.223-1.052-.533a3.09 3.09 0 0 1-1.142-.811 1.65 1.65 0 0 1-.378-1.075 1.576 1.576 0 0 1 .607-1.3 2.494 2.494 0 0 1 1.594-.484z",
    transform: "translate(-173.026 -.107)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4347",
    d: "M280.02 6.437a2.651 2.651 0 0 1 1.228.283 2.057 2.057 0 0 1 .853.792 2.227 2.227 0 0 1 .3 1.154 2.326 2.326 0 0 1-.29 1.177 2.031 2.031 0 0 1-.853.8 2.651 2.651 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.038 2.038 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.624 2.624 0 0 1 1.214-.28m-1.177 2.229a1.583 1.583 0 0 0 .318 1.036 1.043 1.043 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.056 1.056 0 0 0-.843.38 1.5 1.5 0 0 0-.325 1.006",
    transform: "translate(-182.711 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4348",
    d: "M280.02 6.437a2.651 2.651 0 0 1 1.228.283 2.057 2.057 0 0 1 .853.792 2.227 2.227 0 0 1 .3 1.154 2.326 2.326 0 0 1-.29 1.177 2.031 2.031 0 0 1-.853.8 2.651 2.651 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.038 2.038 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.081 2.081 0 0 1 .853-.788 2.624 2.624 0 0 1 1.216-.28zm-1.177 2.229a1.583 1.583 0 0 0 .318 1.036 1.043 1.043 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.322-1.017 1.115 1.115 0 0 0-.874-.359 1.056 1.056 0 0 0-.843.38 1.5 1.5 0 0 0-.324 1.005z",
    transform: "translate(-182.711 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5877",
    transform: "translate(100.641 .139)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h1.14v6.473H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5878",
    transform: "translate(100.641 .139)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    },
    d: "M0 0h1.14v6.473H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4349",
    d: "M302.133 6.681v2.678a.893.893 0 0 0 .211.642.737.737 0 0 0 .558.22.978.978 0 0 0 .552-.176 1.268 1.268 0 0 0 .426-.5V6.681h1.14v4.328h-1.14v-.589a1.8 1.8 0 0 1-1.334.672 1.466 1.466 0 0 1-1.121-.454A1.662 1.662 0 0 1 301 9.452V6.681z",
    transform: "translate(-198.077 -4.397)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4350",
    d: "M302.133 6.681v2.678a.893.893 0 0 0 .211.642.737.737 0 0 0 .558.22.978.978 0 0 0 .552-.176 1.268 1.268 0 0 0 .426-.5V6.681h1.14v4.328h-1.14v-.589a1.8 1.8 0 0 1-1.334.672 1.466 1.466 0 0 1-1.121-.454A1.662 1.662 0 0 1 301 9.452V6.681z",
    transform: "translate(-198.077 -4.397)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4351",
    d: "M316.255 3.321h.093V4.47h1.483v.862h-1.483v2a.614.614 0 0 0 .658.653 1.95 1.95 0 0 0 .918-.287v.913a2.861 2.861 0 0 1-1.158.274 1.57 1.57 0 0 1-1.142-.4 1.437 1.437 0 0 1-.41-1.08V5.332h-.676v-.185z",
    transform: "translate(-206.986 -2.186)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4352",
    d: "M316.255 3.321h.093V4.47h1.483v.862h-1.483v2a.614.614 0 0 0 .658.653 1.95 1.95 0 0 0 .918-.287v.913a2.861 2.861 0 0 1-1.158.274 1.57 1.57 0 0 1-1.142-.4 1.437 1.437 0 0 1-.41-1.08V5.332h-.676v-.185z",
    transform: "translate(-206.986 -2.186)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4353",
    d: "M326.875.827a.62.62 0 0 1 .454.19.621.621 0 0 1 .19.454.638.638 0 0 1-.188.452.623.623 0 0 1-.908 0 .629.629 0 0 1-.193-.452.61.61 0 0 1 .195-.456.628.628 0 0 1 .449-.187m.57 6.33h-1.14V2.829h1.14z",
    transform: "translate(-214.682 -.544)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4354",
    d: "M326.875.827a.62.62 0 0 1 .454.19.621.621 0 0 1 .19.454.638.638 0 0 1-.188.452.623.623 0 0 1-.908 0 .629.629 0 0 1-.193-.452.61.61 0 0 1 .195-.456.628.628 0 0 1 .45-.188zm.57 6.33h-1.14V2.829h1.14z",
    transform: "translate(-214.682 -.544)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4355",
    d: "M334.932 6.437a2.651 2.651 0 0 1 1.228.283 2.057 2.057 0 0 1 .853.792 2.227 2.227 0 0 1 .3 1.154 2.327 2.327 0 0 1-.29 1.177 2.031 2.031 0 0 1-.853.8 2.651 2.651 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.038 2.038 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.08 2.08 0 0 1 .853-.788 2.624 2.624 0 0 1 1.214-.28m-1.177 2.229a1.583 1.583 0 0 0 .318 1.036 1.043 1.043 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.316-1.017 1.115 1.115 0 0 0-.874-.359 1.056 1.056 0 0 0-.843.38 1.5 1.5 0 0 0-.324 1.006",
    transform: "translate(-218.847 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4356",
    d: "M334.932 6.437a2.651 2.651 0 0 1 1.228.283 2.057 2.057 0 0 1 .853.792 2.227 2.227 0 0 1 .3 1.154 2.327 2.327 0 0 1-.29 1.177 2.031 2.031 0 0 1-.853.8 2.651 2.651 0 0 1-1.24.292 2.621 2.621 0 0 1-1.237-.292 2.038 2.038 0 0 1-.846-.8 2.323 2.323 0 0 1-.29-1.177 2.206 2.206 0 0 1 .306-1.161 2.08 2.08 0 0 1 .853-.788 2.624 2.624 0 0 1 1.216-.28zm-1.177 2.229a1.583 1.583 0 0 0 .318 1.036 1.043 1.043 0 0 0 .85.387 1.1 1.1 0 0 0 .876-.371 1.578 1.578 0 0 0 .319-1.061 1.472 1.472 0 0 0-.318-1.017 1.115 1.115 0 0 0-.874-.359 1.056 1.056 0 0 0-.843.38 1.5 1.5 0 0 0-.328 1.005z",
    transform: "translate(-218.847 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4357",
    d: "M351.641 6.437a1.426 1.426 0 0 1 1.11.456 1.718 1.718 0 0 1 .415 1.2v2.752h-1.136V8.212a1.021 1.021 0 0 0-.2-.667.672.672 0 0 0-.549-.246.875.875 0 0 0-.5.155 2.323 2.323 0 0 0-.509.517v2.877h-1.14V6.52h1.14v.607a2.023 2.023 0 0 1 .646-.531 1.634 1.634 0 0 1 .72-.16",
    transform: "translate(-229.754 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4358",
    d: "M351.641 6.437a1.426 1.426 0 0 1 1.11.456 1.718 1.718 0 0 1 .415 1.2v2.752h-1.136V8.212a1.021 1.021 0 0 0-.2-.667.672.672 0 0 0-.549-.246.875.875 0 0 0-.5.155 2.323 2.323 0 0 0-.509.517v2.877h-1.14V6.52h1.14v.607a2.023 2.023 0 0 1 .646-.531 1.634 1.634 0 0 1 .723-.159z",
    transform: "translate(-229.754 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4359",
    d: "M365.116 6.437a2.689 2.689 0 0 1 .672.081 3.427 3.427 0 0 1 .667.257v.913a3.2 3.2 0 0 0-.7-.336 2.062 2.062 0 0 0-.663-.128.691.691 0 0 0-.385.093.3.3 0 0 0-.139.264.267.267 0 0 0 .116.195 4.367 4.367 0 0 0 .635.357 3.88 3.88 0 0 1 1.04.693 1.072 1.072 0 0 1 .3.762 1.207 1.207 0 0 1-.436.985 1.8 1.8 0 0 1-1.177.359 3.494 3.494 0 0 1-.864-.1 2.9 2.9 0 0 1-.665-.246v-.95a3.052 3.052 0 0 0 1.4.463.941.941 0 0 0 .473-.1.311.311 0 0 0 .181-.276.3.3 0 0 0-.065-.185.853.853 0 0 0-.195-.172q-.13-.088-.811-.422a2.317 2.317 0 0 1-.774-.544 1.044 1.044 0 0 1-.25-.7 1.1 1.1 0 0 1 .45-.917 1.9 1.9 0 0 1 1.182-.343",
    transform: "translate(-239.198 -4.236)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4360",
    d: "M365.116 6.437a2.689 2.689 0 0 1 .672.081 3.427 3.427 0 0 1 .667.257v.913a3.2 3.2 0 0 0-.7-.336 2.062 2.062 0 0 0-.663-.128.691.691 0 0 0-.385.093.3.3 0 0 0-.139.264.267.267 0 0 0 .116.195 4.367 4.367 0 0 0 .635.357 3.88 3.88 0 0 1 1.04.693 1.072 1.072 0 0 1 .3.762 1.207 1.207 0 0 1-.436.985 1.8 1.8 0 0 1-1.177.359 3.494 3.494 0 0 1-.864-.1 2.9 2.9 0 0 1-.665-.246v-.95a3.052 3.052 0 0 0 1.4.463.941.941 0 0 0 .473-.1.311.311 0 0 0 .181-.276.3.3 0 0 0-.065-.185.853.853 0 0 0-.195-.172q-.13-.088-.811-.422a2.317 2.317 0 0 1-.774-.544 1.044 1.044 0 0 1-.25-.7 1.1 1.1 0 0 1 .45-.917 1.9 1.9 0 0 1 1.19-.346z",
    transform: "translate(-239.198 -4.236)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4371",
    d: "M6.118-11.08C2.744-11.08.735-9.147.735-6.208c0 2.957 2.009 4.966 5.4 4.966a9.221 9.221 0 0 0 4.417-1v-2.09a8.707 8.707 0 0 1-3.715.948 2.646 2.646 0 0 1-2.671-1.971H10.8v-.682c0-3.413-2.16-5.043-4.682-5.043zM4.071-7a1.845 1.845 0 0 1 1.858-2.014c1.08 0 1.744.758 1.744 2.009zM16.9-14.511c-3.109 0-4.625 1.687-4.625 3.734 0 2.559 2.294 3.545 3.488 4.094 1.858.815 2.123 1.156 2.123 1.706 0 .436-.379.948-1.573.948a7.049 7.049 0 0 1-3.92-1.421v3.185a11.663 11.663 0 0 0 4.53 1.024c2.824 0 4.834-1.5 4.834-3.924 0-2.351-1.971-3.3-3.867-4.189-1.422-.663-1.877-.967-1.877-1.535 0-.531.379-.967 1.384-.967a6.7 6.7 0 0 1 3.81 1.479v-3.052a8.848 8.848 0 0 0-4.307-1.082zm13.4 3.431a4.207 4.207 0 0 0-3.33 1.535v-4.8h-3.336v12.932h3.336v-5.573c.682-1.062 1.327-1.5 2.028-1.5.91 0 1.365.663 1.365 1.8v5.27H33.7v-5.816c0-2.199-.854-3.848-3.394-3.848zm10.388 2.5c1.232 0 1.915.91 1.915 2.407 0 1.535-.7 2.426-1.9 2.426-1.213 0-1.9-.91-1.9-2.426.014-1.533.735-2.405 1.891-2.405zm.019-2.5c-3.526 0-5.4 2.066-5.4 4.91 0 2.862 1.9 4.929 5.4 4.929 3.488 0 5.4-2.066 5.4-4.929.008-2.825-1.868-4.91-5.394-4.91zm17.1 5.023c0-4.341-2.749-4.853-5.365-4.853h-4.621V2.909h3.336v-4.776a4.091 4.091 0 0 0 2.369.626c2.996-.001 4.285-2.484 4.285-4.816zm-6.65-2.35h1.137c1.156 0 2.009.815 2.009 2.313 0 1.479-.569 2.351-1.649 2.351a2.328 2.328 0 0 1-1.5-.493z",
    transform: "translate(62.538 31.932)",
    style: {
      fill: "#333"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEShopLogoSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eShopLogo-small.cc0167e410f5f88bcf38aa0365ae9787.svg";